









































































































import { defineComponent, toRefs, computed, PropType } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  AdgroupConfig,
  fakeOptimizeGoal,
  AdgroupListItem,
  OptimizeGoal,
  CreateMode,
} from '@tt4b/ttam-enums';
import {
  StateEnum,
  useAdgroupAppEvents,
  useStdAdgroupIs,
  useStore,
  useStdObjectiveType,
  useStdAdgroupOptimizationGoal,
} from '@tt4b/ttam-hooks';
import ALink from '@/components/common/a-link/a-link.vue';
import AttributionTips from '@/components/adgroup/attribution-tips/index.vue';
import { trackEvent } from './../../../utils/index';
import { voStatusAppOptions, voStatusWebsiteOptions } from './consts';
import OptimizationGoal from './index';
import { useSelectedApp } from './../../../hooks/creation/adgroup/useSelectedApp/index';

const name = 'ttam-optimization-goal-compose';

export default defineComponent({
  name,
  components: {
    TtamAttributionTips: AttributionTips,
    TtamOptimizationGoalDefaultSelect: OptimizationGoal.TtamOptimizationGoalDefaultSelect,
    TtamOptimizationGoalVideoViewSelect: OptimizationGoal.TtamOptimizationGoalVideoViewSelect,
    TtamOptimizationGoalExplanationHint: OptimizationGoal.TtamOptimizationGoalExplanationHint,
    TtamOptimizationGoalAppTrackUrlTips: OptimizationGoal.TtamOptimizationGoalAppTrackUrlTips,
    TtamOptimizationGoalLabel: OptimizationGoal.TtamOptimizationGoalLabel,
    TtamOptimizationGoalLabelHint: OptimizationGoal.TtamOptimizationGoalLabelHint,
    TtamOptimizationIos14DisabledHint: OptimizationGoal.TtamOptimizationIos14DisabledHint,
    ALink,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
    dcAdgroupList: {
      type: Array as PropType<AdgroupListItem[]>,
      required: true,
      default: () => [],
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig, dcAdgroupList, createMode } = toRefs(props);

    const { selectedAppObj: appInfo } = useSelectedApp({
      adgroupData,
    });

    /** Get Data From Store  */
    const { state } = useStore();
    const appEvents = computed(() => state[StateEnum.appEvents].data.value);
    const voStatus = computed(() => state[StateEnum.voStatus].data.value);

    const { isWebsite } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    /** DefaultSelect  */
    const { options: optimizationGoalOptions } = OptimizationGoal.useDefaultSelectPropsOptions({
      adgroupData,
      campaignData,
      dcAdgroupList,
      appInfo,
      voStatus,
      appEvents,
      createMode,
    });

    const { isInstallWithInAppEvent, setIsInstallDeepEventsModuleShow } = useAdgroupAppEvents({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      appEvents,
    });

    const _optimizationGoal = computed({
      get: () => {
        if (
          isInstallWithInAppEvent.value &&
          optimizationGoalOptions.value?.find?.(
            item => (item.value as number) === (fakeOptimizeGoal.INSTALL_WITH_IN_APP_EVENT as number),
          )
        ) {
          return fakeOptimizeGoal.INSTALL_WITH_IN_APP_EVENT;
        }
        setIsInstallDeepEventsModuleShow(false);

        return adgroupData.value?.optimizeGoal || '';
      },
      set: val => {
        // 一定要写成 _optimizationGoal，与 formData.value.optimizeGoal不完全一致
        if (val === _optimizationGoal.value) {
          // 选了相同选项时候不进行设置
          return;
        }
        if (val === fakeOptimizeGoal.INSTALL_WITH_IN_APP_EVENT) {
          // 这里还是把fake的丢出去，交给外面判断
          emit('optimize-goal-change', val);
          setIsInstallDeepEventsModuleShow(true);
          return;
        }

        setIsInstallDeepEventsModuleShow(false);

        emit('optimize-goal-change', val);
      },
    });

    const handlePopoverApplyClick = (optimizeGoal: OptimizeGoal) => {
      emit('click-apply-optimize-goal', optimizeGoal);
    };

    const { disabled: defaultSelectDisabled } = OptimizationGoal.useDefaultSelectPropsDisabled({
      adgroupData,
      campaignData,
      dcAdgroupList,
      adgroupConfig,
    });

    const noSelection = computed(() => !optimizationGoalOptions.value?.length);
    const selectedOptGoalLabel = computed(() => {
      const item = optimizationGoalOptions.value?.find?.(v => v.value === _optimizationGoal.value);

      return item?.label || '';
    });

    const voStatusConfig = computed(
      () =>
        (isWebsite.value
          ? voStatusWebsiteOptions()[voStatus.value?.valueOptimizerStatus]
          : voStatusAppOptions()[voStatus.value?.valueOptimizerStatus]) || {},
    );

    const voLearnMoreLink = computed(() =>
      isWebsite.value ? '/help/article?aid=10008856' : '/help/article?aid=10007025',
    );

    /** ExplanationTips  */
    const { tips: explanationTips } = OptimizationGoal.useExplanationTipsPropsTips({
      adgroupData,
    });

    /** AppTrackUrlTips  */
    const { visible: appTrackUrlTipsVisible } = OptimizationGoal.useAppTrackUrlTipsPropsVisible({
      adgroupData,
      campaignData,
      appInfo,
    });

    const { linkText: appTrackUrlTipsLinkText } = OptimizationGoal.useAppTrackUrlTipsPropsLinkText({
      adgroupData,
      campaignData,
    });
    const { linkUrl: appTrackUrlTipsLinkUrl } = OptimizationGoal.useAppTrackUrlTipsPropsLinkUrl({
      appInfo,
    });
    const { text: appTrackUrlTipsText } = OptimizationGoal.useAppTrackUrlTipsPropsText({
      adgroupData,
      campaignData,
    });

    /** LabelHint  */
    const { visible: labelHintVisible } = OptimizationGoal.useLabelHintPropsVisible({
      adgroupData,
      campaignData,
      appInfo,
    });

    /**  VideoViewSelect */
    const _videoDurationType = computed({
      get: () => props.adgroupData?.cpvVideoDurationType,
      set: v => {
        _optimizationGoal.value = OptimizeGoal.VIDEO_VIEW;
        emit('video-duration-type-change', v);
      },
    });
    const { options: vvSelectOptions } = OptimizationGoal.useVideoViewSelectPropsOptions();
    const { placeholder: vvSelectPlaceholder } = OptimizationGoal.useVideoViewSelectPropsPlaceholder();
    const { visible: vvSelectVisible } = OptimizationGoal.useVideoViewSelectPropsVisible({
      campaignData,
    });
    const { disabled: vvSelectDisabled } = OptimizationGoal.useVideoViewSelectPropsDisabled({
      adgroupData,
      campaignData,
      dcAdgroupList,
      adgroupConfig,
    });

    /**  ios14DisabledHint */
    const { disabled: ios14HintDisabled } = OptimizationGoal.useIos14DisabeldHintPropsDisabled({
      adgroupData,
      campaignData,
      dcAdgroupList,
    });

    /** attribution-tips  */
    const selectVisible = computed(() => optimizationGoalOptions.value.length > 1);
    const { isEngagement, isAppInstall, isConversion, isDpa } = useStdObjectiveType({
      campaignFormData: campaignData,
    });
    const { isOptGoalClick, isOptGoalInAppEvent } = useStdAdgroupOptimizationGoal({
      adgroupFormData: adgroupData,
    });
    const isShowAttributionWindowTips = computed(() => {
      if (!selectVisible.value) {
        return false;
      }
      if (isAppInstall.value) {
        return !isOptGoalClick.value && !(isOptGoalInAppEvent.value || isInstallWithInAppEvent.value);
      }
      if (isConversion.value || isDpa.value) {
        return !isOptGoalClick.value;
      }
      if (isEngagement.value) {
        return true;
      }

      return false;
    });

    const iconHoverTrack = () => trackEvent('adgroup_optimize_goal_hover');

    const onVisibleChange = (isVisible: boolean) => {
      if (isVisible) {
        trackEvent('create_ad_group_optimization_goal', {
          inventory_flow: adgroupData.value?.inventoryFlow?.join?.(','),
          inventory_flow_type: adgroupData.value?.inventoryFlowType?.toString?.(),
        });
      }
    };

    return {
      name,
      vvSelectOptions,
      _videoDurationType,
      vvSelectVisible,
      vvSelectDisabled,
      vvSelectPlaceholder,

      _optimizationGoal,
      selectVisible,
      optimizationGoalOptions,
      defaultSelectDisabled,
      noSelection,
      selectedOptGoalLabel,

      explanationTips,

      appTrackUrlTipsVisible,
      appTrackUrlTipsLinkText,
      appTrackUrlTipsLinkUrl,
      appTrackUrlTipsText,

      labelHintVisible,

      ios14HintDisabled,

      OptimizeGoal,
      voStatusConfig,
      voLearnMoreLink,

      isShowAttributionWindowTips,

      iconHoverTrack,
      onVisibleChange,

      handlePopoverApplyClick,
    };
  },
});
